@if (visible()) {
  <!-- Overlay -->
  <div
    class="absolute inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity"
    (click)="onOverlayClick()"
    aria-hidden="true"
  ></div>

  <!-- Panel -->
  <div
    role="dialog"
    aria-modal="true"
    class="app-modal__panel relative w-full min-h-0 flex flex-col rounded-2xl border border-[var(--border)] bg-[var(--bg-surface)] shadow-xl"
    [style.--app-modal-max-w]="sizePx()"
    (click)="onContentClick($event)"
  >
    <!-- Header fixo -->
    <div class="flex items-start justify-between gap-4 shrink-0 px-6 pt-6 pb-4 border-b border-[var(--border)]">
      <div class="min-w-0">
        @if (title()) {
          <h2 class="text-lg font-semibold text-[var(--text)]">{{ title() }}</h2>
        }
        @if (subtitle()) {
          <p
            class="mt-0.5 text-sm text-[var(--muted)] truncate"
            [attr.title]="subtitle()"
          >
            {{ subtitle() }}
          </p>
        }
        <ng-content select="[modalHeader]"></ng-content>
      </div>
      <div class="shrink-0 flex items-center gap-3">
        <ng-content select="[modalHeaderActions]"></ng-content>
        @if (showCloseButton()) {
          <button
            type="button"
            (click)="close()"
            class="shrink-0 h-9 w-9 rounded-[var(--r-sm)] hover:bg-[var(--hover)] flex items-center justify-center text-[var(--muted)] ml-1"
            [attr.aria-label]="'common.close' | t"
          >
            <span class="text-lg leading-none">×</span>
          </button>
        }
      </div>
    </div>
    <!-- Body -->
    <div
      class="px-6 overscroll-y-contain"
      [class.min-h-0]="!shrinkWrapBody()"
      [class.flex-1]="!shrinkWrapBody()"
      [class.flex-none]="shrinkWrapBody()"
      [class.shrink-0]="shrinkWrapBody()"
      [class.py-4]="!shrinkWrapBody()"
      [class.py-3]="shrinkWrapBody()"
      [class.overflow-auto]="!bodyFill() && !shrinkWrapBody()"
      [class.overflow-hidden]="bodyFill()"
      [class.flex]="bodyFill()"
      [class.flex-col]="bodyFill()"
    >
      <ng-content select="[modalBody]"></ng-content>
    </div>
    @if (showFooter()) {
      <!-- Footer fixo -->
      <div class="shrink-0 flex items-center justify-end gap-2 px-6 py-4 border-t border-[var(--border)]">
        <ng-content select="[modalFooter]"></ng-content>
      </div>
    }
  </div>
}
